module.exports = __webpack_public_path__ + "static/media/yellow_bg.d6697b1e.svg";